export enum NotificationType {
    ADVISER_STEL = "ADVISER_STEL",
    CLIENT_STEL = "CLIENT_STEL",
    CLIENT_MARGIN_BREACH = "CLIENT_MARGIN_BREACH",
    CLIENT_NO_MARGIN = "CLIENT_NO_MARGIN",
    CLIENT_INITIAL_MARGIN = "CLIENT_INITIAL_MARGIN"
}
